import styled from "styled-components";

export const Container = styled.section`
  margin-top: 10rem;
  padding: 4rem 0;

  h2 {
    font-size: 3rem;
    text-align: left;
    margin-bottom: 3rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .skills-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 2rem;
  }

  .skill-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding: 1.5rem;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
    border-radius: 16px;
    border: 1px solid rgba(102, 126, 234, 0.2);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-8px);
      background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%);
      border-color: rgba(102, 126, 234, 0.4);
      box-shadow: 0 15px 35px rgba(102, 126, 234, 0.2);
    }

    img {
      width: 4rem;
      height: 4rem;
      object-fit: contain;
    }

    .tech-icon {
      font-size: 3.5rem;
      width: 4rem;
      height: 4rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .tech-name {
      font-size: 1rem;
      color: #b8b8ff;
      text-align: center;
      font-weight: 500;
    }
  }

  @media (max-width: 768px) {
    margin-top: 6rem;
    
    h2 {
      font-size: 2.5rem;
      text-align: center;
    }

    .skills-grid {
      grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
      gap: 1.5rem;
    }

    .skill-item {
      padding: 1rem;

      img {
        width: 3rem;
        height: 3rem;
      }

      .tech-icon {
        font-size: 2.5rem;
        width: 3rem;
        height: 3rem;
      }

      .tech-name {
        font-size: 0.9rem;
      }
    }
  }
`;
